import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ShipmentFilterName } from '../../../../../store';
import { ReasonCodeFacade } from '../../../../../store/state/monitoring/reason-code/reason-code.facade';
import { StatusCodeFacade } from '../../../../../store/state/monitoring/status-code/status-code.facade';
import {
  FilterPopupChipsFacade,
  FilterPopupChipsModel,
} from '../../../../../store/state/monitoring/models/filter-popup-chips.model';
import { DialogDataModel } from './mat-chips-filter-dialog.model';

export const chipsFilterDialogFactory = (data: DialogDataModel, store: Store): FilterPopupChipsFacade => {
  if (data.filterName === ShipmentFilterName.ReasonCodes) {
    return new ReasonCodeFacade(store);
  }

  if (data.filterName === ShipmentFilterName.StatusCodes) {
    return new StatusCodeFacade(store);
  }
};

export abstract class ChipsFilterDialogFacade implements FilterPopupChipsFacade {
  abstract items$: Observable<FilterPopupChipsModel[]>;
  abstract load(): void;
}
